import React, { useState } from "react";
import Filter from "./Filter";

export default function TabMenu({
  tabMenuData = [],
  filter,
  handleSelectTab = () => {},
  setDataLoading = () => {},
}) {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    handleSelectTab(tabMenuData[tabNumber]);
    setDataLoading(true);
  };

  return (
    <div className="docpro_wrap">
      <div className="docpro_tab">
        {tabMenuData.map((item, index) => (
          <button
            type="button"
            className={`docpro_tab_item ${activeTab === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)}
            key={index}
          >
            {item}
          </button>
        ))}
      </div>
      {filter && <Filter filterType="general" />}
    </div>
  );
}
